export const accountMovement = {
  accountMovementTransaction: "Transaction",
  accountMovementAmount: "Amount",
  accountMovementDeposit: "Deposits",
  accountMovementTransfer: "Transfers",
  accountMovementBet: "Bets",
  accountMovementWithdrawal: "Withdrawals",
  accountMovementBonus: "Bonuses",
  movementsBtnBack: "Back",
  accountMovementBetAll: "All",
  accountMovementBetWon: "Won",
  accountMovementBetLost: "Lost",
  paginationItemsPerPage: "/ page",
  paginationJumpTo: "Go to",
  paginationJumpToConfirm: "confirm",
  paginationPage: "Page",
  paginationPrevPage: "Previous page",
  paginationNextPage: "Next page",
  paginationPrev5: "Previous 5 pages",
  paginationNext5: "Next 5 pages",
  paginationPrevPageTooltip: "Previous page",
  paginationNextPageTooltip: "Next page",
  paginationOf: "of",
  paginationItems: "items",
};
